module.exports = __webpack_public_path__ + "static/media/easy-sorvete.66caab49.svg";